export const state = () => {
  return {
    activeIndex: 0,
    isTransparent: false, // 首页需要为透明背景
    isWhite: false
    // userIp: '', // 用户ip
    // isNavAnchor: false,
    // isShowMenu: false, // 是否显示菜单
    // isHomePage: false,
    // isScrollAnchor: false // 滚动显示当前激活
  }
}
// 多语言在这里配置的时候注意事项

export const mutations = {
  // 首页滚动道banner位置需要更换背景
  scrollNavBg(state, isTransparent) {
    state.isTransparent = isTransparent
  },
  // 处理 菜单栏 ，如果显示状态下， 导航栏背景色不应变透明
  processShowSubNav(state, isWhite) {
    state.isWhite = isWhite
  }
  // changeNavAnchor(state, isAnchor) {
  //   state.isNavAnchor = isAnchor
  // },
  // // 滚动状态
  // scrollNavAnchor(state, isScrollAnchor) {
  //   state.isScrollAnchor = isScrollAnchor
  // },
  // // 修改请求时的状态
  // storePrevIndex(state, index) {
  //   state.activeIndex = index
  // },
  // storeUserIp(state, userIp) {
  //   state.userIp = userIp
  // },
  // showModalMenu(state, isShowMenu) {
  //   state.isShowMenu = isShowMenu
  // },
  // showRenderHome(state, isHomePage) {
  //   state.isHomePage = isHomePage
  // }
}
